import type { ReactNode } from 'react';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { LabelL } from 'atoms/typography';

const Wrapper = styled.div`
  background: var(--gameweek-date-bg, var(--c-white));
  padding: 2px var(--intermediate-unit);
  border-radius: var(--half-unit);
`;
const Text = styled(LabelL)`
  color: var(--gameweek-date-color, var(--c-black));
`;

type Props = {
  label: ReactNode;
  colors?: { bg?: string; fg?: string };
};
export const HeadlinePill = ({ label, colors }: Props) => {
  return (
    <Wrapper
      style={
        {
          '--gameweek-date-bg': colors?.bg,
          '--gameweek-date-color': colors?.fg,
        } as CSSProperties
      }
    >
      <Text bold>{label}</Text>
    </Wrapper>
  );
};
